import React, { useState, useEffect } from "react";
import { Container, Image, Form, Button, Spinner } from "react-bootstrap";
import "../styles/login.scss";
import { useNavigate } from "react-router";
import { commonPostservice, getCookie } from "../utils/properties";
import { useAppDispatch } from "../app/hooks";
import { showToast } from "../features/Toaster/toastslice";
import { decryptPayload, encryptPayload } from "../utils/auth";

const Login = () => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [userPassword, setUserPassword] = useState<string>("");

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (getCookie() !== undefined) {
      sessionStorage.setItem("isLogin", "yes");
      navigate("/dashboard");
    }
  });

  const handlePasswordShow = () => {
    setShowPassword(!showPassword);
  };

  const handleValidate = () => {
    if (userName.trim() === "") {
      // dispatch(showToast(userName,"Please enter the user name"));
      dispatch(
        showToast({
          message: "Please enter the user name",
          status: "retry",
          visible: true,
        })
      );
      return false;
    } else if (userPassword.trim() === "") {
      // alert("Please enter the password");
      dispatch(
        showToast({
          message: "Please enter the Password",
          status: "retry",
          visible: true,
        })
      );
      return false;
    }
    return true;
  };

  const handleLogin = async () => {
    if (handleValidate()) {
      let params = {
        username: userName,
        password: userPassword,
      };

      const encryptedName = await encryptPayload(userName);
      const encryptedPassword = await encryptPayload(userPassword);


      const decryptedName = await decryptPayload(encryptedName);
      const decryptedPassword = await decryptPayload(encryptedPassword);

      setIsLoading(true);
      commonPostservice(`/api/1.0/auth/login`, {
        username: encryptedName,
        password: encryptedPassword,
      }).then(async (res) => {
        setIsLoading(false);
        if (res.status === 200) {
          let d = new Date();
          d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
          let expireTime = d.toUTCString();
          document.cookie = `X-XSRF-TOKEN = ${res?.data?.token};expires=${expireTime};path=/`;
          sessionStorage.setItem("isLogin", "yes");
          let encryptedRole = await encryptPayload(res?.data?.role);
          localStorage.setItem("roleDetails", encryptedRole);
          let accessiblePages = res?.data?.role?.features
          let navigatePage = accessiblePages?.dashboard?.status ? 'dashboard' : accessiblePages?.manager?.status ? 'managerList' : accessiblePages?.reports?.status ? 'reports' :
            accessiblePages?.screenshot?.status ? 'screenshots' : accessiblePages?.roles?.status ? 'roles' : 'settings'
          // navigate("dashboard");
          navigate(navigatePage);
        } else {
          dispatch(
            showToast({
              message: "Invalid Credentials",
              status: "retry",
              visible: true,
            })
          );
        }
      });
    }
  };

  return (
    <Container fluid className="login-container">
      <div className="body-container d-flex justify-content-center align-items-center">
        <div className="bottom-corner-circle corner-circles"></div>
        <div className="top-corner-circle corner-circles"></div>

        <div className="outer-circle">
          <div className="inner-circle d-flex justify-content-center align-items-center">
            <div className="d-flex flex-column justify-content-center align-items-center">
              <div>
                <Image
                  src="/images/login/timelyze_logo_new.svg"
                  className="logo"
                  alt="Timetracker Logo"
                />
              </div>
              <div className="user-inp">
                <Form.Control
                  type="text"
                  placeholder="Enter Your Username"
                  className="inp-pts"
                  value={userName}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleLogin();
                    }
                  }}
                  onChange={(e) => setUserName(e.target.value)}
                />
              </div>
              <div className="pass-inp position-relative">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Your Password"
                  className="inp-pts"
                  value={userPassword}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleLogin();
                    }
                  }}
                  onChange={(e) => setUserPassword(e.target.value)}
                />
                {!showPassword ? (
                  <Image
                    src="/images/login/password_hide.svg"
                    alt="Password Hide"
                    className="position-absolute cursor-pointer"
                    onClick={handlePasswordShow}
                  />
                ) : (
                  <Image
                    src="/images/login/password_show.svg"
                    alt="Password Show"
                    className="position-absolute cursor-pointer"
                    onClick={handlePasswordShow}
                  />
                )}
              </div>
              <div className="btn-ctr">
                <Button
                  variant="light"
                  onClick={() => handleLogin()}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <Spinner as="span" animation="border" size="sm" />
                  ) : (
                    "Login"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Login;
